<template>
    <v-navigation-drawer
        src="/bg-2.jpg"
        app
        dark
        v-model="drawer"
    >
        <v-list>
            <v-list-item two-line>
            <v-list-item-avatar>
                <img src="/icon.svg">
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title>{{user.username}}</v-list-item-title>
                <v-list-item-subtitle>SoundAnalytics</v-list-item-subtitle>
            </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item
                v-for="item in permittedItems"
                :key="item.title"
                link
                :to="item.link"
            >
            <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
        </v-list>

    </v-navigation-drawer>
</template>

<script>
    export default {
        data: () => ({
            items: [
                { title: 'Home', icon: 'mdi-google-maps', link: '/', rol:'reporter'},
                { title: 'Dash Board', icon: 'mdi-monitor-dashboard', link: '/dashboard', rol:'user'},
                { title: 'Dispositivos', icon: 'mdi-home-analytics', link: '/devices', rol:'user'},
                { title: 'Resumen', icon: 'mdi-calendar-range', link: '/resume', rol:'dev'},
                { title: 'Comparar', icon: 'mdi-compare', link: '/compare', rol:'user'},
                { title: 'Descargas', icon: 'mdi-cloud-download', link: '/downloads', rol:'user'},
                { title: 'Crear Projectos', icon: 'mdi-clipboard-plus', link: '/projects/import', rol:'dev'},
                { title: 'Ver Projectos', icon: 'mdi-chart-line', link: '/projects/view', rol:'dev'},
            ],
            drawer: true
        }),

        computed: {
            user () {
                return this.$store.getters.user
            },

            toggleDrawer () {
                return this.$store.getters.drawer
            },

            permittedItems () {
                return this.items.filter ( e => {
                    return this.user.roles.some ( u => {
                        return u.name === e.rol
                    })
                })
            }
        },

        watch: {
            toggleDrawer (val) {
                this.drawer = val
            },
            drawer (val) {
                this.$store.dispatch('toggleDrawer', val)
            }
        }
    }
</script>
